import HttpResponse from "../../../../../../utils/http/http.response";

export enum BillingsOrderForwardRelatedTaxiDriverResponseItemContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type BillingsOrderForwardRelatedTaxiDriverResponseItemTaxiTaxiCorporation =
  {
    displayName: string;
  };

export type BillingsOrderForwardRelatedTaxiDriverResponseItemTaxiDriverAssociation =
  {
    taxiCorporation: BillingsOrderForwardRelatedTaxiDriverResponseItemTaxiTaxiCorporation;
  };

export type BillingsOrderForwardRelatedTaxiDriverResponseItemPlanEntry = {
  humanId: string;
};

export type BillingsOrderForwardRelatedTaxiDriverResponseItemContract = {
  taxiDriverAssociation: BillingsOrderForwardRelatedTaxiDriverResponseItemTaxiDriverAssociation;
  distanceRate: number;
  model: BillingsOrderForwardRelatedTaxiDriverResponseItemContractBillingModel;
};

export type BillingsOrderForwardRelatedTaxiDriverResponseItem = {
  id: string;
  sumOfBonuses: number;
  sumOfPenalties: number;
  draft: boolean;
  distance: number;
  amountForChargeHighways: number | null;
  amountForChargeHaltings: number | null;
  allContributionsAmount: number | null;
  amountForDistance: number | null;
  date: Date;
  planEntry: BillingsOrderForwardRelatedTaxiDriverResponseItemPlanEntry;
  contract: BillingsOrderForwardRelatedTaxiDriverResponseItemContract;
};

type BillingsOrderForwardRelatedTaxiDriverResponse = HttpResponse<
  BillingsOrderForwardRelatedTaxiDriverResponseItem[]
>;

export default BillingsOrderForwardRelatedTaxiDriverResponse;
